//新建、编辑服务询报价弹窗
<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="getTitle"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form :model="dialogData" :rules="rules" ref="dialogForm" label-width="150px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="服务类型" prop="serviceName">
              <el-select
                v-model="dialogData.serviceName"
                placeholder="请选择服务"
                style="width: 100%"
                @change="(value) => selectValueHandler('service', value)"
              >
                <el-option
                  v-for="(item, index) in tempServiceTypes"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="费用类型" prop="expenseName">
              <el-select
                v-model="dialogData.expenseName"
                placeholder="费用类型"
                @change="(value) => selectValueHandler('expense', value)"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in expenseList"
                  :key="index"
                  :label="item.expenseName"
                  :value="item.expenseName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" prop="remarks">
              <el-input v-model="dialogData.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="线路名" prop="routeName">
              <!-- <el-input v-model="dialogData.routeName"></el-input> -->
              <el-select
                v-model="dialogData.routeName"
                placeholder="请选择线路名"
                @change="selectRouteHandler"
                style="width: 100%"
                :disabled="serviceRuleDisabled"
              >
                <el-option
                  v-for="(item, index) in routes"
                  :key="index"
                  :label="item.routeName"
                  :value="item.routeCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="启运地" prop="departurePlaceName">
              <el-input v-model="dialogData.departurePlaceName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="目的地" prop="destinationName">
              <el-input v-model="dialogData.destinationName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="商品名称" prop="productParentName">
              <el-select
                v-model="dialogData.productParentName"
                placeholder="请选择商品"
                clearable
                @change="selectProductHandler"
                :disabled="serviceRuleDisabled"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in parentProducts"
                  :key="index"
                  :label="item.productParentName"
                  :value="item.productParentName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品子类简码" prop="productDetailCode">
              <!-- <search-table
                :value="dialogData.productDetailCode"
                searchType="goodsAllCategory"
                :isMultiple="true"
                clearable
                :currentValue="dialogData.productDetailCode"
                :checkRowKeys="[dialogData.productDetailCode]"
                :extraData="{
                  productParentCode: dialogData.productParentCode,
                }"
                :disabled="!dialogData.productParentCode || serviceRuleDisabled"
                @input="selectProductDetailHandler"
                placeholder="请选择子类"
              >
              </search-table> -->
              <el-select
                v-model="dialogData.productDetailCode"
                placeholder="请选择商品子类编码"
                clearable
                :disabled="
                  !dialogData.productParentCode || serviceRuleDisabled || detailProducts.length == 1
                "
                @change="selectProductDetailHandler"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in detailProducts"
                  :key="index"
                  :label="item.productDetailCode"
                  :value="item.productDetailCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品目" prop="detailProductItems">
              <el-input v-model="dialogData.detailProductItems" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="规格" prop="detailProductModel">
              <el-input v-model="dialogData.detailProductModel" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="5">
            <el-form-item label="数量" prop="qty" >
              <input-number-ad
                v-model="dialogData.qty"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="2"
                :clearable="true"
                class="inputWidth"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="qtyUnit" label-width="1px">
              <el-select v-model="dialogData.qtyUnit" placeholder="件数单位">
                <el-option
                  v-for="(item, index) in qtyUnitList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="计费单位" prop="chargeUnit">
              <el-select
                v-model="dialogData.chargeUnit"
                placeholder="请选择计费单位"
                style="width: 100%"
                @change="(value) => selectValueHandler('chargeUnit', value)"
              >
                <el-option
                  v-for="(item, index) in unitTypeList"
                  :key="index"
                  :label="item.unitName"
                  :value="item.unitNo"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="箱型" prop="cubeType">
              <el-select
                v-model="dialogData.cubeType"
                placeholder="请选择箱型"
                style="width: 100%"
                @change="(value) => selectValueHandler('cubeType', value)"
              >
                <el-option
                  v-for="(item, index) in containerTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="otherTitle != '服务计费规则'">
          <el-col :span="8">
            <el-form-item label="供方报价" prop="supplierInquiry">
              <input-number-ad
                v-model="dialogData.supplierInquiry"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="3"
                :clearable="true"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户初次报价" prop="customerInitialQuotation">
              <input-number-ad
                v-model="dialogData.customerInitialQuotation"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="3"
                :clearable="true"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户最终报价" prop="customerFinalQuotation">
              <input-number-ad
                v-model="dialogData.customerFinalQuotation"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="3"
                :clearable="true"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8" v-if="otherTitle == '服务计费规则'">
            <el-form-item label="计费含税单价" prop="unitPriceWithTax">
              <input-number-ad
                v-model="dialogData.unitPriceWithTax"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="3"
                :clearable="true"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import { checkZero } from './columns';
  export default {
    name: 'EditFreightDialog',
    mixins: [IntermodalityCommonMixin],
    props: {
      otherTitle: {
        type: String,
        default: () => '服务询报价',
      },
    },
    components: { inputNumberAd },
    data() {
      return {
        rules: {},
        dialogVisible: false,
        dialogData: {
          serviceName: null,
          serviceCode: null,
          expenseName: null,
          expenseType: null,
          remarks: null,
          routeName: null,
          routeCode: null,
          departurePlaceName: null,
          departurePlaceCode: null,
          destinationName: null,
          destinationCode: null,
          productParentName: null,
          detailProductItems: null,
          detailProductModel: null,
          productParentCode: null,
          productDetailCode: null,
          // qty: 0,
          // qtyUnit: null,
          chargeUnit: null,
          chargeUnitName: null,
          supplierInquiry: 0,
          customerInitialQuotation: 0,
          customerFinalQuotation: 0,
          //合同独有字段
          unitPriceWithTax: 0,
          cubeType: null,
          cubeTypeName: null,
          xid: null,
        },
        isEditModal: false,
        routes: [],
        cargos: [],
        tempServiceTypes: [],
        productProducts: [],
        detailProducts: [],
      };
    },
    mounted() {
      this.tempServiceTypes = { ...this.serviceTypeList };
    },
    computed: {
      getTitle() {
        if (this.isEditModal) {
          return '编辑' + this.otherTitle;
        } else {
          return '新建' + this.otherTitle;
        }
      },
      serviceRuleDisabled() {
        let disabled = false;
        if (
          ['公路装卸服务', '咨询服务', '仓储服务', '监管服务', '铁路装卸服务'].includes(
            this.dialogData.serviceName
          )
        ) {
          disabled = true;
        }
        return disabled;
      },
    },
    methods: {
      getParentProducts() {
        let products = [];
        if (this.cargos && this.cargos.length != 0) {
          this.cargos.forEach((item) => {
            if (products.length == 0) {
              products.push(item);
            } else {
              let nameList = products.map((item) => item.productParentName);
              if (!nameList.includes(item.productParentName)) {
                products.push(item);
              }
            }
          });
        }
        this.parentProducts = products;
      },
      getDetailProducts() {
        let products = [];
        if (this.cargos && this.cargos.length != 0) {
          products = this.cargos.filter(
            (item) => item.productParentCode == this.dialogData.productParentCode
          );
        }
        this.detailProducts = products;
      },
      getRules() {
        this.rules = {
          serviceName: [{ required: true, message: '请选择服务名称' }],
          expenseName: [{ required: true, message: '请选择费用类型' }],
          // routeName: [{ required: true, message: '请选择路线' }],
          // productParentName: [{ required: true, message: '请选择商品名称' }],
          // qty: [
          //   { required: true, message: '请输入数量' },
          //   { trigger: 'change', validator: checkZero },
          // ],
          // qtyUnit: [{ required: true, message: '请选择数量单位' }],
          chargeUnit: [{ required: true, message: '请选择计费单位' }],
          supplierInquiry: [{ required: true, message: '请输入供方报价' }],
          unitPriceWithTax: [
            { required: true, message: '必填字段' },
            { trigger: 'change', validator: checkZero },
          ],
          customerInitialQuotation: [{ required: true, message: '请输入客户初次报价' }],
        };

        if (this.dialogData.chargeUnit == 'ByCase') {
          this.rules.cubeType = [{ required: true, message: '请选择箱型' }];
        } else {
          this.rules.cubeType = [];
        }

        if (this.dialogData.serviceCode == 0 || this.dialogData.serviceCode == 1) {
          this.rules.routeName = [{ required: true, message: '请选择路线' }];
          this.rules.productParentName = [{ required: true, message: '请选择商品名称' }];
        }
        this.$nextTick(() => {
          this.$refs.dialogForm.clearValidate();
        });
      },
      //服务
      selectValueHandler(type, val) {
        switch (type) {
          case 'service':
            this.dialogData.serviceName = val;
            this.dialogData.serviceCode = this.tempServiceTypes.find(
              (item) => item.label == val
            ).value;
            console.log('serviceCode', this.dialogData.serviceCode);
            this.clearExpenseData();
            this.clearChargeUnitData();
            this.getExpenseTypes(this.dialogData.serviceCode);

            if (this.serviceRuleDisabled) {
              this.dialogData = {
                ...this.dialogData,
                routeCode: null,
                routeName: null,
                departurePlaceName: null,
                departurePlaceCode: null,
                destinationName: null,
                destinationCode: null,
                productParentName: null,
                detailProductItems: null,
                detailProductModel: null,
                productParentCode: null,
                productDetailCode: null,
              };
            }

            this.getRules();

            break;
          case 'expense':
            this.dialogData.expenseName = val;
            this.dialogData.expenseType = this.expenseList.find(
              (item) => item.expenseName == val
            ).expenseNo;
            this.clearChargeUnitData();
            this.unitTypeList = this.expenseList.find((item) => item.expenseName == val).typeUnits;
            break;
          case 'chargeUnit':
            this.dialogData.chargeUnit = val;
            this.dialogData.chargeUnitName = this.unitTypeList.find(
              (item) => item.unitNo == val
            ).unitName;
            this.getRules();
            break;
          case 'cubeType':
            console.log(val);
            this.dialogData.cubeType = val;
            this.dialogData.cubeTypeName = this.containerTypeList.find(
              (item) => item.value == val
            ).label;
            break;
          default:
            break;
        }
        // this.dialogData.serviceName = row ? row[0].serviceName : null;
      },
      clearExpenseData() {
        this.expenseList = [];
        this.dialogData.expenseName = null;
        this.dialogData.expenseType = null;
      },
      clearChargeUnitData() {
        this.unitTypeList = [];
        this.dialogData.chargeUnit = null;
        this.dialogData.chargeUnitName = null;
        this.getRules();
      },
      selectRouteHandler(routeCode) {
        let route = this.routes.find((item) => item.routeCode == routeCode);
        if (route) {
          this.dialogData.routeName = route.routeName;
          this.dialogData.routeCode = route.routeCode;
          this.dialogData.departurePlaceCode = route.departurePlaceCode;
          this.dialogData.destinationCode = route.destinationCode;
          let departureDetail =
            route.departurePlaceDetail != null && route.departurePlaceDetail?.length != 0
              ? route.departurePlaceDetail
              : '';

          let destinationDetail =
            route.destinationDetail != null && route.destinationDetail?.length != 0
              ? route.destinationDetail
              : '';
          this.dialogData.departurePlaceName = route.departurePlaceName + departureDetail;
          this.dialogData.destinationName = route.destinationName + destinationDetail;
        }
      },
      //商品名称
      selectProductHandler(name) {
        this.dialogData.productParentName = name;
        let product = this.cargos.find((item) => item.productParentName == name);

        if (!product || !name || name.length == 0) {
          this.dialogData.productParentCode = null;
          this.dialogData.productDetailCode = null;
          this.dialogData.detailProductItems = null;
          this.dialogData.detailProductModel = null;
        }
        if (product) {
          this.dialogData.productParentCode = product.productParentCode;
          this.getDetailProducts();

          if (this.detailProducts.length == 1) {
            let item = this.detailProducts[0];
            this.dialogData.productDetailCode = item.productDetailCode;
            this.dialogData.detailProductItems = item.detailProductItems;
            this.dialogData.detailProductModel = item.detailProductModel;
          }

          // this.dialogData.productDetailCode = product.productDetailCode;
          // this.dialogData.detailProductItems = product.detailProductItems;
          // this.dialogData.detailProductModel = product.detailProductModel;
          // this.dialogData.qty = product.qty;
          // this.dialogData.qtyUnit = product.qtyUnit;
        }
      },
      selectProductDetailHandler(code) {
        let product = this.cargos.find((item) => item.productDetailCode == code);
        this.dialogData = {
          ...this.dialogData,
          productDetailCode: code,
          detailProductItems: product.detailProductItems,
          detailProductModel: product.detailProductModel,
        };
        // this.dialogData.productDetailCode = row[0].productDetailCode ?? row[0].parentProductNo;
        // this.dialogData.detailProductItems = row ? row[0].detailProductItems : null;
        // this.dialogData.detailProductModel = row ? row[0].detailProductModel : null;
      },
      async openModal(rowData = {}, cargos = [], routes = [], products = [], services = []) {
        console.log(products);
        this.dialogVisible = true;
        if (Object.keys(rowData).length) {
          this.isEditModal = true;
          for (let key in this.dialogData) {
            this.dialogData[key] = rowData[key];
          }
          this.dialogData.xid = rowData._XID;
        } else {
          this.isEditModal = false;
          for (let key in this.dialogData) {
            this.dialogData[key] = null;
          }
        }

        //过滤掉没有生效的服务
        let tempServices = [];
        services.forEach((rawItem) => {
          let passList = Array.from(this.serviceTypeList);
          passList.forEach((passItem) => {
            if (rawItem == passItem.label) {
              tempServices.push(rawItem);
              console.log('添加服务', passItem);
            }
          });
        });
        console.log('可以勾选的服务', tempServices);

        this.tempServiceTypes = this.serviceTypeDictList.filter((item) =>
          tempServices.includes(item.label)
        );

        if (this.dialogData.serviceCode) {
          await this.getExpenseTypes(this.dialogData.serviceCode);
          if (this.dialogData.expenseName) {
            this.unitTypeList = this.expenseList.find(
              (item) => item.expenseName == this.dialogData.expenseName
            ).typeUnits;
          }
        }
        this.routes = routes;
        this.cargos = cargos;
        this.getRules();
        this.getParentProducts();
        this.getDetailProducts();
      },
      cancelHandler() {
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
        this.dialogVisible = false;
        // Object.assign(this.$data,this.$option.data())
      },
      confirmHandler() {
        this.$refs.dialogForm.validate(async (valid) => {
          if (valid) {
            const data = { ...this.dialogData };
            this.$emit('confirmHandler', data, this.isEditModal);
            this.cancelHandler();
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style> -->
